const validate = values => {
  const errors = {};
  if (!values.ati_data_ini) {
    errors.ati_data_ini = 'Campo Obrigatório';
  }
  if (!values.ati_data_fim) {
    errors.ati_data_fim = 'Campo Obrigatório';
  }
  if (!values.ati_titulo) {
    errors.ati_titulo = 'Campo Obrigatório';
  }
  if (!values.ati_qtd_ten) {
    errors.ati_qtd_ten = 'Campo Obrigatório';
  }
  if (!values.disciplinas) {
    errors.disciplinas = 'Campo Obrigatório';
  }
  if (!values.ati_tipo) {
    errors.ati_tipo = 'Campo Obrigatório';
  }
  if (!values.ati_ati_per) {
    errors.ati_ati_per = 'Campo Obrigatório';
  }
  if (!values.ati_questao_a) {
    errors.ati_questao_a = 'Campo Obrigatório';
  }
  if (!values.ati_questao_b) {
    errors.ati_questao_b = 'Campo Obrigatório';
  }
  if (!values.ati_questao_c) {
    errors.ati_questao_c = 'Campo Obrigatório';
  }
  if (!values.ati_questao_d) {
    errors.ati_questao_d = 'Campo Obrigatório';
  }
  if (!values.ati_resposta) {
    errors.ati_resposta = 'Campo Obrigatório';
  }
  if (!values.ati_que_tempo) {
    errors.ati_que_tempo = 'Campo Obrigatório';
  }
  if (!values.ati_pal_tempo) {
    errors.ati_pal_tempo = 'Campo Obrigatório';
  }
  if (!values.ati_per) {
    errors.ati_per = 'Campo Obrigatório';
  }else if (values.ati_per.length > 123) {
    errors.ati_per = 'Este campo deve ter 123 caractere no máximo.'
  }

  if (!values.ati_pal) {
    errors.ati_pal = 'Campo Obrigatório';
  } else if (!/^[a-z]+$/.test(values.ati_pal)) {
 // } else if (!/^[A-Za-z0-9-]+$/.test(values.ati_pal)) {
    errors.ati_pal = 'Não é permitido espaço,acentuação,numeros e letras maiúscula.'
  }else if (values.ati_pal.length > 12) {
    errors.ati_pal = 'Este campo deve ter 40 caractere no máximo.'
  }





  // if (!values.ati_pal_chave) {
  //   errors.ati_pal_chave = 'Campo Obrigatório';
  // } else if (!/^[a-z]+$/.test(values.ati_pal_chave)) {
  //   errors.ati_pal_chave = 'Não é permitido acentuação,numeros e letras maiúscula.'
  // }else if (values.ati_pal_chave.length > 40) {
  //   errors.ati_pal_chave = 'Este campo deve ter 40 caractere no máximo.'
  // }

  return errors;
};

export default validate;






// WEBPACK FOOTER //
// ./src/service/validade_missoes.js